import { AssetSchema } from '@babyn-yar/schema';
import { API_URL } from '../context';
import { fetcher } from '../fetcher';
import { toSearchParams } from '../params';
import * as v from 'valibot';
export var AssetAPI;
(function (AssetAPI) {
    const BASE_URL = API_URL + '/assets';
    async function list(page, filters) {
        const params = toSearchParams(filters);
        params.set('page', page.toString());
        params.set('page_size', '50');
        const url = new URL(BASE_URL);
        url.search = params.toString();
        const response = await fetcher(url);
        return v.parse(AssetSchema.ListResponse, response);
    }
    AssetAPI.list = list;
    async function remove(ids) {
        const params = toSearchParams({ ids: ids.join(',') });
        const url = new URL(BASE_URL);
        url.search = params.toString();
        return fetcher(url, { method: 'DELETE' });
    }
    AssetAPI.remove = remove;
    async function upload(form) {
        const formData = new FormData();
        form.files.forEach(({ file, fileName, extension }) => {
            const prefix = form.prefix ? form.prefix + '_' : '';
            const fullName = `${prefix}${fileName}.${extension}`;
            formData.append('assets', file, fullName);
        });
        const response = await fetcher(BASE_URL, { method: 'POST', body: formData });
        return v.parse(AssetSchema.FormResponse, response);
    }
    AssetAPI.upload = upload;
})(AssetAPI || (AssetAPI = {}));
